"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue, Ref } from "vue-property-decorator";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import _ from "lodash";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import GridSelector from "@/components/dialog/GridSelector.vue";
import { APIDataSource } from "@/components/grid/data-source";
import { Debounce } from "vue-debounce-decorator";
import { AddRulesController } from "../AddRulesPage.vue";
import API from "@ym-framework/api-utils";
const DepartmentSelector = () => import("@/components/dialog/GridSelector.vue");
const RoleSelector = () => import("@/components/dialog/GridSelector.vue");
let AddRulesChooseMembersDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.byMembersController = new GridController(
      new APIDataSource("api://base.auth/api/v7/users")
    );
    this.departmentList = [];
    this.departmentProps = {
      label: "label",
      children: "children"
    };
    this.dialog = new UiDialogController();
    this.activeName = "first";
    this.byMemberselectDatas = [];
    this.byDepartmentselectDatas = [];
    this.byDepartmentselectLock = false;
    this.byMemberselectLock = false;
    this.searchStrbyMember = "";
    this.searchStrbyDepartment = "";
  }
  created() {
    return __async(this, null, function* () {
      this.byMembersController.on("searched", (item) => {
        this.byMembercheckItem();
      });
      this.byMembersController.pagePosition = "dialog";
      this.byMembersController.size = true;
      this.byMembersController.query.filter = `userStatus=='0'`;
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open(datas) {
    return __async(this, null, function* () {
      this.byMemberselectDatas = [];
      this.byMemberselectLock = false;
      this.byDepartmentselectDatas = [];
      this.byDepartmentselectLock = false;
      this.dialog.visible = true;
      this.$nextTick(() => __async(this, null, function* () {
        if (this._formController.rulesSelector === "users") {
          yield this.byMembersController.search();
          if (datas) {
            for (let data of datas) {
              console.log(data);
              let item = _.find(this.byMembersController.result.datas, {
                id: data.id
              });
              if (item !== void 0) {
                this._byMembersTable.toggleRowSelection(item, true);
                this.byMemberselectDatas.push(item);
              }
            }
          }
        }
        if (this._formController.rulesSelector === "department") {
          yield this.getDepartmentTrees();
          if (datas) {
            this.byDepartmentselectDatas = datas;
            for (let data of datas) {
              this._departmentTree.setChecked(data.id, true);
            }
          }
        }
        if (this._formController.rulesSelector === "role") {
        }
      }));
    });
  }
  changeChoice(mode) {
    return __async(this, null, function* () {
      try {
        this._formController.rulesSelectorMembers = [];
        if (mode === "users") {
          this.byMembersController.query.sort = "asc";
          this.byMembersController.query.filter = `userStatus=='0'`;
          this.byMembersController.search();
        }
        if (mode === "department") {
          yield this.getDepartmentTrees();
        }
        if (mode === "role") {
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getDepartmentTrees() {
    return __async(this, null, function* () {
      try {
        let arr = [];
        let response = yield API.get(`api://base.auth/api/v7/departments`);
        arr.push(response.data);
        this.departmentList = arr;
        this.byDepartmentcheckItem();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  byDepartmentselectItems(items) {
    this.byDepartmentselectDatas = items;
    if (!this.byDepartmentselectLock) {
      for (const item of items) {
        const _item = {
          id: item.id,
          label: item.label
        };
        this._byDepartmentsGridSelector.add(_item);
      }
    }
  }
  byMemberselectItems(items) {
    this.byMemberselectDatas = items;
    if (!this.byMemberselectLock) {
      let unSelectData = _.differenceWith(
        this.byMembersController.result.datas,
        items,
        _.isEqual
      );
      for (const item of items) {
        const _item = {
          id: item["guid"],
          label: `${item["name"]} (${this.getId(item["account"])})`
        };
        this._byMembersGridSelector.add(_item);
      }
      for (const item of unSelectData) {
        const _item = {
          id: item["guid"],
          label: `${item["name"]} (${this.getId(item["account"])})`
        };
        this._byMembersGridSelector.del(_item);
      }
    }
  }
  byMemberChanged(data) {
    let rows = _.differenceWith(
      this.byMemberselectDatas,
      data,
      (selectData, data2) => selectData.guid == data2.id
    );
    this.byMemberselectLock = true;
    if (rows) {
      for (const row of rows) {
        this._byMembersTable.toggleRowSelection(row, false);
      }
    }
    this.byMemberselectLock = false;
  }
  byMembercheckItem() {
    var _a;
    let selectDatas = (_a = this._byMembersGridSelector) == null ? void 0 : _a.getAll();
    let rows = _.intersectionWith(
      this.byMembersController.result.datas,
      selectDatas,
      (selectData, data) => selectData.guid == data.id
    );
    this.byMemberselectLock = true;
    if (rows) {
      for (const row of rows) {
        this._byMembersTable.toggleRowSelection(row, true);
      }
    }
    this.byMemberselectLock = false;
  }
  byDepartmentcheckItem() {
    var _a;
    let selectDatas = (_a = this._byDepartmentsGridSelector) == null ? void 0 : _a.getAll();
    let rows = _.intersectionWith(
      this.departmentList,
      selectDatas,
      (selectData, data) => selectData.id == data.id
    );
    this.byDepartmentselectLock = true;
    if (rows) {
      for (const row of rows) {
        this._departmentTree.setChecked(row.id, true);
      }
    }
    this.byDepartmentselectLock = false;
  }
  byMembersearchByName(searchStr) {
    return __async(this, null, function* () {
      if (searchStr !== null && searchStr !== "") {
        this.byMembersController.query.filter = `userStatus=='0';name=='%${searchStr}%',account=='%${searchStr}%'`;
      }
      if (searchStr === null || searchStr === "") {
        this.byMembersController.query.filter = `userStatus=='0'`;
      }
      this.byMembersController.query.current = 1;
      this.byMembersController.search();
    });
  }
  byDepartmentSearchName(searchStr) {
    return __async(this, null, function* () {
      this._departmentTree.filter(searchStr);
    });
  }
  filterNode(value, data) {
    if (!value)
      return true;
    return data.label.indexOf(value) !== -1;
  }
  byDepartmentChanged(data) {
    console.log(data);
    if (data && data.length > 0) {
      let rows = _.differenceWith(
        this.byDepartmentselectDatas,
        data,
        (selectData, data2) => selectData.id == data2.id
      );
      this.byDepartmentselectLock = true;
      if (rows) {
        for (const row of rows) {
          let item = this.byDepartmentselectDatas.find(function(value) {
            return value.id === row.id;
          });
          this._departmentTree.setChecked(row.id, false);
        }
      }
      this.byDepartmentselectLock = false;
    } else {
      this.byDepartmentselectDatas = [];
      let checkedIds = this._departmentTree.getCheckedKeys();
      for (const id of checkedIds) {
        this._departmentTree.setChecked(id, false);
      }
    }
  }
  byRolesChanged(data) {
  }
  //切换树形框架选择器
  handleCheckChange(data, isChecked) {
    if (isChecked) {
      this.byDepartmentselectDatas.push(data);
      let new_data = {
        id: data.id,
        label: data.label
      };
      this._byDepartmentsGridSelector.add(new_data);
    } else {
      let item = this.byDepartmentselectDatas.find(function(value) {
        return value.id === data.id;
      });
      if (item) {
        let new_data = {
          id: item.id,
          label: item.label
        };
        this.byDepartmentselectDatas.splice(item, 1);
        this._byDepartmentsGridSelector.del(new_data);
      }
    }
  }
  cancel() {
    this.dialog.visible = false;
  }
  confirm(datas) {
    try {
      if (this._formController.rulesSelector === "all") {
        this.dialog.visible = false;
      }
      if (this._formController.rulesSelector === "users") {
        this.$emit("changeMembers", { datas });
        this.cancel();
      }
      if (this._formController.rulesSelector === "department") {
        this.$emit("changeMembers", { datas });
        this.cancel();
      }
    } catch (error) {
      if (error.hasOwnProperty("response")) {
        this.$message.error(error.response.data.errors.datas[0].message);
      }
    }
  }
  getId(account) {
    return account.toString().substring(account.toString().length - 4, account.toString().length);
  }
};
__decorateClass([
  PropSync("formController", {
    type: Object,
    default: () => new AddRulesController()
  })
], AddRulesChooseMembersDialog.prototype, "_formController", 2);
__decorateClass([
  Ref("byMembersTable")
], AddRulesChooseMembersDialog.prototype, "_byMembersTable", 2);
__decorateClass([
  Ref("byMembersGridSelector")
], AddRulesChooseMembersDialog.prototype, "_byMembersGridSelector", 2);
__decorateClass([
  Ref("byDepartmentsGridSelector")
], AddRulesChooseMembersDialog.prototype, "_byDepartmentsGridSelector", 2);
__decorateClass([
  Ref("department-tree")
], AddRulesChooseMembersDialog.prototype, "_departmentTree", 2);
__decorateClass([
  Debounce(500)
], AddRulesChooseMembersDialog.prototype, "byMembersearchByName", 1);
AddRulesChooseMembersDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiGrid,
      GridSelector,
      DepartmentSelector,
      RoleSelector
    }
  })
], AddRulesChooseMembersDialog);
export {
  AddRulesChooseMembersDialog as default
};
